/* 
  setting glide js for the partner single pages.

  Handles slider setup.
  removes controlls for mobile
  and changes the preViewVal (number of visible images) on resize
*/

// scrollbar
import Glide from "@glidejs/glide";
import RuOverlayScrollbar from "./../components/overlayscrollbars.js";

// Scrollbar for vp buttons
const vpPartnerScrollbar = new RuOverlayScrollbar("#scrollbars_vpalliance");

const glideSlides = document.querySelector(".glide__slides");
const slidesCount = glideSlides.dataset.slidesCount;
console.log("slidesCount", slidesCount);

let glideType;
let autoplayVal;
let perViewVal;
let isSingle;
let intialLoad = true;

// set initial setup based on slides count
switch (true) {
  case slidesCount == 1:
    glideType = "slider";
    autoplayVal = false;
    perViewVal = 1;
    isSingle = true;
    break;
  case slidesCount >= 1:
    glideType = "carousel";
    autoplayVal = 5000;
    perViewVal = 1.4;
    isSingle = false;
    break;
}

// run fn when content is loaded
document.addEventListener(
  "DOMContentLoaded",
  function () {
    // Scrollbar for vp buttons
    const vpPartnerScrollbar = new RuOverlayScrollbar("#scrollbars_vpalliance");

    // init glide.js
    const glide = new Glide(".glide", {
      type: glideType,
      autoplay: autoplayVal,
      hoverpause: false,
      animationDuration: 1500,
      gap: 0,
      perView: perViewVal,
    });

    // remove slider controlls if only one slide
    if (isSingle) {
      const glideControlls = document.querySelector(".glide-controlls");
      glideControlls.style.display = "none";
    }

    //////////////////////////////
    // Glide resize observer for different screen width
    const partnerGlide = document.querySelector(".glide");
    const partnerGlideObserver = new ResizeObserver((elements) => {
      elements.forEach((element) => {
        switch (true) {
          case element.contentRect.width >= 599.98:
            changeGlide(1.4); // set preViewVal
            intialLoad ? initGlide() : ""; // check porevents multiple instanzes

            break;
          case element.contentRect.width <= 599.98 ||
            (element.contentRect.width >= 599.98 && isSingle):
            changeGlide(1); // set preViewVal
            intialLoad ? initGlide() : ""; // check porevents multiple instanzes

            break;
        }
      });
    });

    partnerGlideObserver.observe(partnerGlide); // run glide observer for screen width

    // init glide
    const initGlide = () => {
      intialLoad = false;
      glide.mount();
    };

    // update preViewVal - how many images are on the screen
    const changeGlide = (perViewVal) => {
      glide.update({ perView: perViewVal });
      console.log("updateVieVal", perViewVal);
    };
  },
  false
);
